import { IntakeMultiStep } from "@/components";
import { NewIntakeLayout } from "@/layout";

export const NewIntake = () => {
  return (
    <NewIntakeLayout>
      <div>
        <IntakeMultiStep />
      </div>
    </NewIntakeLayout>
  );
};
